import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var LocationPinSvg = function LocationPinSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.527 7.782H9.473v5.072h5.054zm-3.676 3.69V9.165h2.298v2.305z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2.249c-5.211 0-8.5 3.653-8.5 8.07 0 1.465.548 2.928 1.312 4.264.767 1.342 1.78 2.605 2.777 3.686a34 34 0 0 0 3.972 3.65l.018.014.005.004.002.001.414.311.413-.31-.413-.554.414.553.002-.001.005-.004.018-.014a15 15 0 0 0 .326-.256 33.969 33.969 0 0 0 3.646-3.394c.997-1.08 2.01-2.344 2.777-3.686.764-1.336 1.312-2.799 1.312-4.265 0-4.416-3.289-8.069-8.5-8.069m0 19.136-.414.553zm.771-1.524c-.308.266-.571.484-.771.645a32.577 32.577 0 0 1-3.4-3.177c-.955-1.036-1.895-2.214-2.593-3.435-.7-1.226-1.129-2.445-1.129-3.576 0-3.64 2.66-6.686 7.122-6.686s7.122 3.046 7.122 6.686c0 1.131-.429 2.35-1.13 3.576-.697 1.22-1.637 2.4-2.592 3.435a33 33 0 0 1-2.629 2.532",
    clipRule: "evenodd"
  }));
};
export var LocationPin = function LocationPin(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: LocationPinSvg
  }));
};